import { Controller } from "@hotwired/stimulus"

// dropdown — generic show/hide popover that toggles the Tailwind `hidden`
// CLASS on its menu target (unlike dropdown-filter, which flips the hidden
// ATTRIBUTE).
//
// Markup (see app/views/shared/_division_filter.html.erb):
//   <div data-controller="dropdown">
//     <button data-action="click->dropdown#toggle">Label</button>
//     <div data-dropdown-target="menu" class="hidden ...">…</div>
//   </div>
//
// Some consumers wrap a native <details>/<summary> that needs no JS and has
// no menu target (see settings/carrier_accounts/index.html.erb). The
// controller guards on hasMenuTarget so it is a harmless no-op there.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._onDocClick = this._onDocClick.bind(this)
    this._onKeydown = this._onKeydown.bind(this)
  }

  disconnect() {
    this._stopListening()
  }

  toggle(event) {
    event.preventDefault()
    if (!this.hasMenuTarget) return
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    if (!this.hasMenuTarget) return
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this._onDocClick, true)
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    if (!this.hasMenuTarget) return
    if (this.menuTarget.classList.contains("hidden")) return
    this.menuTarget.classList.add("hidden")
    this._stopListening()
  }

  _onDocClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  _onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  _stopListening() {
    document.removeEventListener("click", this._onDocClick, true)
    document.removeEventListener("keydown", this._onKeydown)
  }
}
